<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  
  <div class='global-panel' v-loading.body="loading.main">
    <div class='global-header'>
      <div class='global-title'>邮件中心</div>
      <div class='global-tbar'>
        <el-button size="small" type="primary" @click="visible.testDialog=true">测试邮件</el-button>
        <el-input size="small" placeholder="地址" v-model="condition.address"></el-input>
        <el-input size="small" placeholder="标题" v-model="condition.subject"></el-input>
        <el-button size="small" type="default" @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <div class="global-paging" v-show="paging.allNum > paging.everySize" >
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
      <el-table :data="systemMails" border stripe style="width: 100%" size="mini">
        <el-table-column prop="sendTime" label="发送时间" width="140"></el-table-column>
        <el-table-column prop="address" label="地址" width="200"></el-table-column>
        <el-table-column prop="subject" label="主题" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="内容" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="attachmentName" label="附件名" width="150"></el-table-column>
        <el-table-column prop="attachmentType" label="类型" width="50"></el-table-column>
        <el-table-column prop="attachmentContent" label="附件内容" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="state" label="状态" width="80"></el-table-column>
        <el-table-column prop="sendCount" label="发送次数" width="80"></el-table-column>
        <el-table-column prop="errCause" label="错误原因" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button class="global-text-btn-danger" size="mini" type="text" @click="remove(scope.row)" style="margin-left: 10px;">删除</el-button>
        </template>
        </el-table-column>
      </el-table>
      <div class="global-paging" v-show="paging.allNum > paging.everySize" >
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
    </div>
  </div>
  
  <!-- ---------------------- 编辑弹窗 ---------------------- -->
  
  <el-dialog :visible.sync="visible.editDialog" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editDialog">
      <el-form ref="form" :model="systemMail" :rules="rules" label-width="60px" size="small">
        <el-form-item label="发送时间" prop="sendTime">
          <el-input v-model="systemMail.sendTime" readonly></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-input v-model="systemMail.state" readonly></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="systemMail.address"></el-input>
        </el-form-item>
        <el-form-item label="主题" prop="subject">
          <el-input v-model="systemMail.subject"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" v-model="systemMail.content"></el-input>
        </el-form-item>
        <el-form-item label="附件名" prop="attachmentName">
          <el-input v-model="systemMail.attachmentName"></el-input>
        </el-form-item>
        <el-form-item label="附件类型" prop="attachmentType">
          <el-input v-model="systemMail.attachmentType"></el-input>
        </el-form-item>
        <el-form-item label="附件内容" prop="attachmentContent">
          <el-input type="textarea" v-model="systemMail.attachmentContent"></el-input>
        </el-form-item>
        <el-form-item label="业务ID" prop="businessId">
          <el-input v-model="systemMail.businessId"></el-input>
        </el-form-item>
        <el-form-item label="业务类型" prop="businessType">
          <el-input v-model="systemMail.businessType"></el-input>
        </el-form-item>
        <el-form-item label="发送次数" prop="sendCount">
          <el-input v-model="systemMail.sendCount" readonly></el-input>
        </el-form-item>
        <el-form-item label="错误原因" prop="errCause">
          <el-input type="textarea" v-model="systemMail.errCause" readonly></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="save" style="margin-left: 80px">保存</el-button>
        <el-button size="small" type="danger" @click="reSend">重发</el-button>
        <el-button size="small" type="warning" @click="downloadAttach">下载附件</el-button>
        <el-button size="small" type="default" @click="visible.editDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>
  <el-dialog :visible.sync="visible.testDialog" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.testDialog">
      <el-form ref="testForm" :model="testSystemMail" :rules="rules" label-width="60px" size="small">
        <el-form-item label="地址" prop="address">
          <el-input v-model="testSystemMail.address"></el-input>
        </el-form-item>
        <el-form-item label="主题" prop="subject">
          <el-input v-model="testSystemMail.subject"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" v-model="testSystemMail.content"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="sendTextMail">发送文字邮件</el-button>
        <el-button size="small" type="warning" @click="sendTextAttach">发送文字附件</el-button>
        <el-button size="small" type="danger" @click="sendBinaryAttach">发送文件附件</el-button>
        <el-button size="small" type="default" @click="visible.testDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>
  
</div>
</template>

<script>

export default {
  name: 'SystemMailIndex',
  data () {
    return {
      // 系统邮件列表
      systemMails: [],
      // 遮罩
      loading: {main: false, editDialog: false, testDialog: false},
      // 可见
      visible: {editDialog: false, testDialog: false},
      // 条件
      condition:{},
      // 系统邮件
      systemMail: {},
      // 测试邮件
      testSystemMail: {},
      // 校验规则
      rules: {
        address: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        subject: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        content: [
          { required: true, message: '该项必填', trigger: 'change' }
        ]
      },
      // 分页
      paging: {currPage: 1, everySize: 20, allNum: 0}
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';

    vm.findByCondition();
  },
  
  methods: {
    /*
     * 查询所有
     */
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      // 请求后台
      vm.$http.get('rest/sys/systemMail/findByCondition', {params: params}).then(response => {
        vm.systemMails = response.body.systemMails;
        vm.paging = response.body.pagingBean;
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    
    /*
     * 编辑
     */
    edit: function (record) {
      var vm = this
      vm.visible.editDialog = true
      vm.systemMail = JSON.parse(JSON.stringify(record));
    },
    
    /*
     * 删除
     */
    remove: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + record.sendTime+'_'+record.address + ']的邮件吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.delete('rest/sys/systemMail/'+String(record.id)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition(vm.paging.currPage)
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    
    /*
     * 保存
     */
    save: function () {
      var vm = this;
      // 校验
      vm.$refs['form'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemMail/saveData', vm.systemMail).then(function (response) {
          vm.systemParam = response.body;
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.editDialog = false
          vm.findByCondition(vm.paging.currPage)
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    },
    /*
     * 重发
     */
    reSend: function () {
      var vm = this;
      vm.$confirm('确定要重发该邮件吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.post('rest/sys/systemMail/reSend/'+String(vm.systemMail.id)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition(vm.paging.currPage)
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '重发成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '重发失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '重发取消'});
      });
    },
    /*
     * 发送文字邮件
     */
    sendTextMail: function () {
      var vm = this;
      // 校验
      vm.$refs['testForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.testDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemMail/sendTextMail', vm.testSystemMail).then(function (response) {
          // 关闭遮罩
          vm.loading.testDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.testDialog = false
          vm.findByCondition(vm.paging.currPage)
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    },
    /*
     * 发送文字附件
     */
    sendTextAttach: function () {
      var vm = this;
      // 校验
      vm.$refs['testForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.testDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemMail/sendTextAttach', vm.testSystemMail).then(function (response) {
          // 关闭遮罩
          vm.loading.testDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.testDialog = false
          vm.findByCondition(vm.paging.currPage)
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    },
    /*
     * 发送文件附件
     */
    sendBinaryAttach: function () {
      var vm = this;
      // 校验
      vm.$refs['testForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.testDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemMail/sendBinaryAttach', vm.testSystemMail).then(function (response) {
          // 关闭遮罩
          vm.loading.testDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.testDialog = false
          vm.findByCondition(vm.paging.currPage)
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    },
    /*
     * 下载附件
     */
    downloadAttach: function () {
      let vm = this;
      let xhr = new XMLHttpRequest();
      xhr.open('POST','/rest/sys/systemMail/download',true);
      xhr.responseType = 'arraybuffer';
      xhr.setRequestHeader("Content-Type","application/json;charset=utf-8");
      xhr.onreadystatechange = function(event) {
        if (this.readyState == 4 && this.status == 200 ) {
          let contentDisposition = xhr.getResponseHeader('Content-Disposition');
          let index = contentDisposition.indexOf("attachment; filename=");
          let fileName = "未知文件"
          if(index>=0) {
            fileName = contentDisposition.substring(index + 21);
          }
          //生成Blob对象，通过创建的a标签点击下载
          var objectUrl = URL.createObjectURL(new Blob([this.response]));
          var link = document.createElement("a");
          link.download = decodeURIComponent(fileName);
          link.href = objectUrl;
          link.click();
        } else if(this.readyState == 4 && this.status != 200 ) {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '下载失败'});
          // 异常处理
          vm.$baize.handle(vm, {status:this.status,body:this.response});
        }
      };
      xhr.send(JSON.stringify({id:vm.systemMail.id}));
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/system/systemmail/SystemMailIndex.vue